<ng-container *ngFor="let l of labels">
  <div class="fiche-label" *ngIf="l.id == label.id" tooltip [tooltipContent]="label.name" [tooltipPosition]="'bottom'">
    <media-attachment [url]="baseUrl + l.image" [optimized]="false" [height]="size" [width]="size" [fill]='false' [alt]="label.name"></media-attachment>
  </div>
</ng-container>
